<h1 mat-dialog-title>Ritten in range verwijderen</h1>

<div mat-dialog-content class="delete-rides">
  <form [formGroup]="deleteForm">
    <div class="date-from-to">
      <mat-form-field class="rides-from">
        <mat-label>Van</mat-label>
        <input matInput [matDatepicker]="from" formControlName="deleteRidesFrom" />
        <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="from"></mat-datepicker-toggle>
        <mat-datepicker #from></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="rides-to">
        <mat-label>Tot en met</mat-label>
        <input matInput [matDatepicker]="to" formControlName="deleteRidesTo" />
        <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="to"></mat-datepicker-toggle>
        <mat-datepicker #to></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="warning">
      @if (deleteRideTxt() && !deleteRideTxtError()) {
        <p class="no-margin">
          {{ deleteRideTxt() }}
        </p>
      }
      @if (deleteRideTxt() && !deleteRideTxtError()) {
        <p class="no-margin">worden alle ritten verwijderd.</p>
      }
      @if (deleteRideTxt() && !deleteRideTxtError()) {
        <p class="agree">Ga je hiermee akkoord?</p>
      }
      @if (deleteRideTxtError()) {
        <p class="no-margin">
          {{ deleteRideTxtError() }}
        </p>
      }
      @if (dateCheckPass()) {
        <span class="date-check-pass">
          <button
            mat-icon-button
            type="button"
            class="green"
            aria-label="Verwijderen bevestigen"
            (click)="deleteRidesInRange()"
          >
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button type="button" class="red" aria-label="Verwijderen annuleren" (click)="cancelRange()">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      }
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Annuleren</button>
  <button
    mat-flat-button
    type="button"
    (click)="checkRange()"
    [class.spinner]="deletingRides()"
    [disabled]="deletingRides()"
  >
    Verwijderen
  </button>
</div>
